module.exports = __webpack_public_path__ + "static/img/3.81f67f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jxhh/3.png
// module id = P3Ur
// module chunks = 2